export default defineNuxtPlugin(() => {
    const checkoutStore = useCheckoutStore()

    try {
        const referrer = document.referrer
        const currentHost = window.location.host

        if (referrer) {
            const referrerUrl = new URL(referrer)

            const isExternalReferrer =
                referrerUrl.host && referrerUrl.host !== currentHost

            if (isExternalReferrer) {
                localStorage.setItem('externalReferrer', referrer)
                checkoutStore.orderReferrer = referrer
            } else {
                const storedReferrer = localStorage.getItem('externalReferrer')

                if (storedReferrer && !checkoutStore.orderReferrer) {
                    checkoutStore.orderReferrer = storedReferrer
                }
            }
        } else {
            const storedReferrer = localStorage.getItem('externalReferrer')

            if (storedReferrer && !checkoutStore.orderReferrer) {
                checkoutStore.orderReferrer = storedReferrer
            }
        }
    } catch (e) {
        console.warn(e)
    }
})
